/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const Login = () => import('@/views/auth/login');
const LoginMail = () => import('@/views/auth/loginMail');
const PasswordChange = () => import('@/views/auth/passwordChange');

/**
 * Defined Router
 */
export default [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/login-mail',
        name: 'LoginMail',
        component: LoginMail,
        meta: {
            title: 'パスワードの問い合わせ',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/password-change',
        name: 'PasswordChange',
        component: PasswordChange,
        meta: {
            title: 'パスワードの変更',
            layout: 'EmptyLayout'
        }
    }
];
